export const getHealthColor = (health: number) => {
	if (health >= 85) return '#34C38F'; // green
	if (health >= 75) return '#FFD992'; // lime
	if (health >= 55) return '#E3A63D'; // amber
	if (health >= 35) return '#ff9191'; // orange
	if (health === null) return '#4A4A4A'; // dark grey
	return '#ff4d4f'; // dark grey
};


export const getSourceColorByIndex = (index: number) => {
	if (index == 0) return '#57F4EC';
	if (index == 1) return '#F46A6A';
	if (index == 2) return '#22A2CA';
	if (index == 3) return '#1C2993';
	return '#6366F1';
};